import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import {
    classIf,
    convertToDecimalWithPrecision,
    getConfiguration,
    getCurrencyValue, getNumberOfCols, getPotentialWinning,
    getSelectionsFromBetWidget,
    truncateDoubleTo
} from '../../data/utils';
import { getLabel } from '../../InitData';
import StatsToggle from '../../common/StatsToggle';
import PrematchContext from '../../contexts/PrematchContext';

function SoffiataPanel(props) {
    const prematchContext = React.useContext(PrematchContext);
	const betslipContext = useContext(BetslipContext) ;
	const conf = getConfiguration();

	let couponData = {};
	
	// calculate potential winnings and the betslip selections
	for (let index in props.data) {
		// duplicate the props data
		let coupon = JSON.parse(JSON.stringify(props.data[index]));
		let selections = getSelectionsFromBetWidget(coupon);
		coupon.cartSelections = selections;
		let potentialWinning = 0;
		let totalOdd = 1;
		for (let k in selections) {
			let selection = selections[k];
			let bet = selection.bets[0];
			totalOdd = totalOdd * convertToDecimalWithPrecision(bet.odd, 19, 6)/100;
			totalOdd = convertToDecimalWithPrecision(totalOdd, 19, 6);
		}
		potentialWinning = parseInt(totalOdd * coupon.totalAmountRaw);
		potentialWinning = getCurrencyValue(potentialWinning, conf.cs.m, conf.cs.nd, conf.cs.ct);
		coupon.totalWinnings = potentialWinning;
		coupon.totalOdds = truncateDoubleTo(totalOdd, 2);
		couponData[index] = coupon;
		couponData[index].events.sort((a, b) =>a.timestamp.localeCompare(b.timestamp));

	}
	
	function putInBetslip(index) {
		let coupon = couponData[index];
		betslipContext.putSelections(coupon.cartSelections, coupon.totalAmountRaw, null);
	}
	
	return (
		<div className="tab-pane fade show active" id="scheda-top-match-3" role="tabpanel">
			<div className="la-soffiata-container">
				{Object.keys(couponData).map(function (i) {
					let fav = couponData[i];
					return (
						<React.Fragment key={i}>
							<div className="titolo-blocco-sport bg-nero bianco allinea-centro margine-su-mezzo">
								<p className="nome-partita-sport font-weight-bold"><i className="fas fa-star mr-1"></i> {fav.desc}</p>
							</div>
							<div className="la-soffiata-box margine-giu bg-bianco nero">
								{fav.events.map((match, i) => {
                                    function handleClick() {
                                        const tournamentUniqueId = `${match.sportRef}_${match.categoryRef}_${match.tournamentRef}`;
                                        prematchContext.openEvent(tournamentUniqueId, match);
                                    }

									return (
                                        <React.Fragment key={i}>
                                            <div className="contenitoreRiga">
                                                <div className="tabellaQuoteNew text_s1 tabellaQuotePrematch tabellaQuotePrematch_5col" data-numero-quote={"" + getNumberOfCols(fav.events[0].scommessa.odds)} data-numero-gruppi-quote="1">
                                                    <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">
                                                        <p>{match.alias}</p>
                                                    </div>
                                                    <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                                        <p>{match.date}</p>
                                                    </div>
                                                    <div className="tabellaQuoteSquadre pointer" onClick={handleClick}>
                                                        <p className="font-weight-bold m-0 text-right">{match.team1}</p>
                                                        {match.team2 != null &&
                                                            <>
                                                                <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">vs</p>
                                                                <p className="font-weight-bold m-0 text-left">{match.team2}</p>
                                                            </>
                                                        }
                                                    </div>
                                                    <div className="tabellaQuoteStatistiche">
                                                        <StatsToggle className="fas fa-chart-bar stat-sel pointer" match={match} />
                                                    </div>
                                                    {match.scommessa.odds.map((odd, j) =>
                                                        <React.Fragment key={j}>
                                                            <div className="tabellaQuoteContenitoreQuotazioni">
                                                                <div className="contenitoreSetQuotazioni">
                                                                    <div className="tipologiaQuotazione_FormaCompatta grigio text-center py-1">
                                                                        <p>{match.scommessa.desc}</p>
                                                                    </div>
                                                                    <div className="gridInterernaQuotazioni">
                                                                        {match.scommessa.odds.map(odd =>
                                                                            <div key={odd.id} className={"contenitoreSingolaQuota quotaSingolaConNomeSquadra bordo-tondo mx-1" + classIf(match.selectedOdd === odd.id, 'selezionata')}>
                                                                                <p className="titoloQuotazione text-uppercase grigio mb-1">
                                                                                    {odd.desc}</p>
                                                                                <p className="tipoQuotazione_1">{odd.value}</p>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    );
								})}
								<div className="totale-soffiata">
                                    <div className="sinistra">
                                        <span className="margine-dx-mezzo">{getLabel('prematch_page.widget.la_soffiata.total_amount')}:<span className="colore-1 margine-sx-mezzo">{fav.totalAmount}</span></span>
                                        <span className="margine-dx-mezzo">{getLabel('prematch_page.widget.la_soffiata.button.total_odds')}<span className="colore-1 margine-sx-mezzo">{fav.totalOdds}</span></span>
                                        <span className="margine-dx-mezzo font-weight-bold">{getLabel('prematch_page.widget.la_soffiata.button.total_winnings')}:<span className="colore-1 margine-sx-mezzo">{fav.totalWinnings}</span></span>
                                    </div>
                                    <div className="destra">
                                        <button onClick={() => putInBetslip(i) } className="bottone-exa pointer bg-verde maisucolo bordo-tondo font-weight-bold">{getLabel('prematch_page.widget.la_soffiata.button.buy')}</button>
                                    </div>
                                </div>
							</div>
						</React.Fragment>
					)
				})}
			</div>
		</div>
	);
}

export default SoffiataPanel;
